import * as reactRouterDom from 'react-router-dom';

import type { ComponentProps, ComponentType } from 'react';

export type WithRouterAddedProps = {
    history: reactRouterDom.NavigateFunction;
    location: reactRouterDom.Location;
    params: reactRouterDom.Params;
    match: {
        params: reactRouterDom.Params;
    };
};

export const withRouter = <TProps extends ComponentProps<ComponentType>>(component: ComponentType<TProps>) => {
    const Wrapper = (props: Omit<TProps, keyof WithRouterAddedProps>) => {
        const history = reactRouterDom.useNavigate();
        const location = reactRouterDom.useLocation();
        const params = reactRouterDom.useParams();
        const match = { params };
        const Component = component as ComponentType<TProps | WithRouterAddedProps>; // Force typescript to let us pass the router props. Might be a better solution but can't figure out how to get typescript to understand that these props are not supposed to be given by the user.
        return <Component history={history} location={location} params={params} match={match} {...props} />;
    };
    return Wrapper;
};

export default withRouter;
